import createMentionsDecorator from './core';
import { Mention } from 'src/components/rich-text-editor/style.js';

export default createMentionsDecorator(Mention);
